module.exports = __webpack_public_path__ + "img/x.b7cda0ed.svg";